import { render, staticRenderFns } from "./DoctorDeviceDeleteModal.vue?vue&type=template&id=4a4bd8ed&scoped=true"
import script from "./DoctorDeviceDeleteModal.vue?vue&type=script&lang=js"
export * from "./DoctorDeviceDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4bd8ed",
  null
  
)

export default component.exports